// roles.js
import {
  collection,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDocs,
  getDoc,
  doc,
} from 'firebase/firestore'
import { homeDb as db } from '@pulse/firebase/firebaseapi' // global data: always the home database
import { COLLECTIONS } from '../../constants/constants'

export const getAllRoles = async (limitValue = 10, startAfterDoc = null) => {
  try {
    const rolesCollectionRef = collection(db, COLLECTIONS.ROLES)
    const queryConstraints = [where('type', '==', import.meta.env.VITE_PORTAL), orderBy('createdAt'), limit(limitValue)]

    if (startAfterDoc) {
      queryConstraints.push(startAfter(startAfterDoc))
    }

    const rolesQuery = query(rolesCollectionRef, ...queryConstraints)
    const querySnapshot = await getDocs(rolesQuery)

    const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]

    return {
      data,
      lastVisible,
    }
  } catch (error) {
    console.error('Error fetching role data:', error)
    return { data: [] }
  }
}
export const getUserRole = async (userId, type) => {
  try {
    const roleRef = doc(db, COLLECTIONS.USERS, userId, COLLECTIONS.ROLES, type)
    const roleDoc = await getDoc(roleRef)
    return roleDoc.exists() ? roleDoc.data() : null
  } catch (error) {
    console.error('Error fetching role data:', error)
  }
}
